const global = window

// Remplissage automatique
inputs.behavior.autofill = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.autofill) {
        if (typeof data.autofill == 'string') data.autofill = [data.autofill]
        data.autofillBinding = function(target) {
            $.each(data.autofill, function (index, field) {

                // console.log(field);
                // console.log(target.find('[data-id="' + field + '"]'));
                target.find('[data-id="' + field + '"]').change(function () {
                    let newVal = []
                    $.each(data.autofill, function (index, field) {
                        field = $('[data-id="' + field + '"]')
                        if (field.length && field.val().trim()) {
                            newVal.push(field.val().trim())
                        }
                    })
                    newVal = newVal.join(' ').trim()
                    // formatPermalien

                    input.data('use-placeholder', true)
                    
                    let formatedVal = newVal;
                    if (data.type != 'email') {
                        formatedVal = formatPermalien(formatedVal);
                    }

                    input.attr('placeholder', formatedVal)
                    input.data('placeholder', formatedVal)
                    if (formatedVal == formatPermalien(input.val())) {
                        input.val('')
                    }
                })

                target.find('[data-id="' + field + '"]').keyup(function () {
                    $(this).change()
                })

                // quand le champ perd le focus
                input.focusout(function () {
                    setTimeout(function () {
                        input.attr('placeholder', input.data('placeholder'))
                    }, 100)
                })
            })
        }
        data.autofillBinding(inputWindow);
        BEHAV.add(data.autofillBinding, inputWindow.data('behavkey'));
    }
    return data
}
